import React__default from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useAnimation, motion } from 'framer-motion';
import useTimer from '../../utils/hooks/useTimer.js';
import { getBadgeIcon } from './util.js';
import { useLocalization } from '../Provider/Provider.js';

const Toast = ({
  content,
  lastUpdated,
  onClose: handleClose,
  options,
  ...props
}) => {
  const {
    texts
  } = useLocalization();
  const {
    autoClose,
    type = 'default'
  } = options;
  const className = cn('bg-white relative flex items-center py-1 px-2 mt-3 w-full rounded yt-shadow', {
    'border border-grey': type === 'default' || type === 'loading' || !type,
    'border border-grey-darker': type === 'success',
    'border border-blue': type === 'information',
    'border border-yellow-dark': type === 'warning',
    'border border-red': type === 'error'
  });
  const timer = useTimer(autoClose, handleClose);
  const controls = useAnimation();

  if (!content) {
    console.warn(`Toast requires 'content' property, which can't be empty string, null or undefined. Current content value is set to ${content === '' ? 'empty string' : content}.`);
  }

  React__default.useEffect(() => {
    if (autoClose) {
      timer.start();
    }
  }, [autoClose]);

  const triggerUpdateAnimation = function () {
    try {
      return Promise.resolve(controls.start({
        scale: 1.05
      })).then(function () {
        return Promise.resolve(controls.start({
          scale: 1
        })).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  React__default.useEffect(() => {
    if (lastUpdated) {
      triggerUpdateAnimation();

      if (timer.running) {
        timer.start();
      }
    }
  }, [lastUpdated]);
  return React__default.createElement(motion.div, Object.assign({}, props, {
    animate: controls,
    className: className,
    "data-taco": "toast",
    onMouseEnter: timer.pause,
    onMouseLeave: timer.resume
  }), getBadgeIcon(type), React__default.createElement("div", {
    className: "flex-grow"
  }, content), React__default.createElement(IconButton, {
    appearance: "discrete",
    className: "text-grey-darkest -mr-2 cursor-pointer self-start !px-0",
    icon: "close",
    "aria-label": texts.toasts.dismiss,
    onClick: handleClose
  }));
};

export { Toast };
//# sourceMappingURL=Toast.js.map
